import { createSlice } from "@reduxjs/toolkit";

const initialState = { content_Id: [], content_Name: "", content_Type: "" };

const mapContentSlice = createSlice({
    name: "mapContent",
    initialState,
    reducers: {
        getSelectedContent: (state, action) => {
            const { rowSelection, tableValues } = action.payload;
            const content_id = Object.keys(rowSelection).map(String);
            const content_name = tableValues.filter((data) => data.ic_content_id === parseInt(content_id[0])).map(content => content.ic_content_name).toString();
            const content_Type = tableValues.filter((data) => data.ic_content_id === parseInt(content_id[0])).map(content => content.ic_content_type).toString();

            return { ...state, content_Id: content_id, content_Name: content_name, content_Type: content_Type };
        },
    },
});

export const { getSelectedContent } = mapContentSlice.actions;

export default mapContentSlice.reducer;
